import {
  DOCUMENT_NUMBER_SEARCH_REQUEST,
  DOCUMENT_NUMBER_SEARCH_SUCCESS,
  DOCUMENT_NUMBER_SEARCH_FAILURE,
  DOCUMENT_NUMBER_SEARCH_RESET,
} from '../actions/search_document_number'

export const searchDocumentNumberTransactions = (
  state = {
    isFetching: false,
    errorMessage: null,
    count: 0,
    countsByDocumentNumber: {},
  },
  action
) => {
  switch (action.type) {
    case DOCUMENT_NUMBER_SEARCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case DOCUMENT_NUMBER_SEARCH_SUCCESS: {
      // Attempt to extract the document_number query param from the requestUrl stored by middleware
      let docNumber = null
      if (action.requestUrl) {
        try {
          const url = new URL(action.requestUrl, 'http://dummy')
          docNumber = url.searchParams.get('document_number')
        } catch (e) {
          // ignore parsing errors
        }
      }
      const nextCounts = { ...state.countsByDocumentNumber }
      if (docNumber) {
        nextCounts[docNumber] = action.response.count
      }
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        count: action.response.count,
        countsByDocumentNumber: nextCounts,
      }
    }
    case DOCUMENT_NUMBER_SEARCH_FAILURE:
      return {
        ...state,
        errors: null,
        isFetching: false,
        errorMessage: action.error,
      }
    case DOCUMENT_NUMBER_SEARCH_RESET:
      return {
        ...state,
        errors: null,
        isFetching: false,
        errorMessage: null,
        count: 0,
        countsByDocumentNumber: {},
      }
    default:
      return state
  }
}
